import React from 'react';
import { HStack, Button } from '@chakra-ui/react';
import { ProjectViewMode } from '../utils/projectViewPreferences';

interface ProjectViewToggleProps {
  mode: ProjectViewMode;
  onChange: (mode: ProjectViewMode) => void;
  size?: 'xs' | 'sm' | 'md';
}

export const ProjectViewToggle: React.FC<ProjectViewToggleProps> = ({
  mode,
  onChange,
  size = 'sm',
}) => (
  <HStack
    gap={0}
    borderWidth={1}
    borderColor="gray.200"
    borderRadius="full"
    bg="gray.50"
    p="2px"
    flexShrink={0}
  >
    <Button
      size={size}
      variant="ghost"
      borderRadius="full"
      px={3}
      fontWeight="semibold"
      bg={mode === 'kanban' ? 'white' : 'transparent'}
      color={mode === 'kanban' ? 'gray.800' : 'gray.500'}
      boxShadow={mode === 'kanban' ? 'sm' : 'none'}
      _hover={{ bg: mode === 'kanban' ? 'white' : 'gray.100' }}
      onClick={() => onChange('kanban')}
      aria-pressed={mode === 'kanban'}
    >
      Board
    </Button>
    <Button
      size={size}
      variant="ghost"
      borderRadius="full"
      px={3}
      fontWeight="semibold"
      bg={mode === 'list' ? 'white' : 'transparent'}
      color={mode === 'list' ? 'gray.800' : 'gray.500'}
      boxShadow={mode === 'list' ? 'sm' : 'none'}
      _hover={{ bg: mode === 'list' ? 'white' : 'gray.100' }}
      onClick={() => onChange('list')}
      aria-pressed={mode === 'list'}
    >
      List
    </Button>
  </HStack>
);
